import { extractTextFromQuery } from '../../../utils/query';
import { activity_name_$ilike_includes } from '../../../utils/query-helpers';

export default {
  param: extractTextFromQuery,
  query: function (text) {
    const words = text.trim().split(' ');

    if (text) {
      return {
        $or: words.map(function(word){
          return {
            project: {
              $where: {
                title: {
                  $ilike: `%${word}%`
                }
              }
            }
          };
        }).concat(words.map(function(word){
          return {
            project: {
              $where: {
                ...activity_name_$ilike_includes(word)
              }
            }
          };
        }))
      }
    }
  }
}
